module.exports = __webpack_public_path__ + "img/icon-report-trend.8f75d6ac.png";